import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { ListExportTransportComponent } from './component/list-export-transport.component';
import { StructureNodeSelectionModule } from '../../../components/structure-node-selection/structure-node-selection.module';
import { CommonUIModule } from '@sdbn/common';

import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [
    ListExportTransportComponent
  ],
  imports: [
    CommonModule,
    CommonUIModule,
    DictionaryModule,

    MatTableModule,
    MatSortModule,
    ReactiveFormsModule,
    FormsModule,
    StructureNodeSelectionModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,

    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatInputModule,
    MatCheckboxModule
  ]
})
export class ListExportTransportsModule { }
